const StreamProviderCode = Object.freeze({
    None: "NONE",
    StretchLive: "STRETCHLIVE"
});

export default StreamProviderCode;
